import { boundSetFeedback } from '../../../../store/actions/feedback.actions';
import RecapCommande from '../../RecapCommande';
import React from 'react';
import { ClearClientActions } from 'store/actions/client.actions';
import { ClearCartAction } from 'store/actions/panier.actions';
import { capture } from '../../../../services/sentry/capture';
import { CommandeErrorMessage } from 'components/organisms/Error/CommandeErrorMessage';
import { AddCommandesAndNoteMutation } from '../../../../graphql/generated/graphql';
import { ButtonWithText } from '../../../atoms/Buttons/ButtonWithText';
import { GET_LEADERS } from '../../../../graphql/query/leaderBoard/leaders.query';
import { getCommandeDefWithEleveFromQuery } from '../../../../helpers/transformApiResponse/commande';
import { QUERY_CLASSE_INFO } from '../../../../graphql/query/classe/queryClasseInfos';
import { QUERY_GET_MY_NOTE_IN_CLASSE } from '../../../../graphql/query/note/getNoteQuery';
import { MY_ID } from '../../../../helpers/user/authorization';
import { QUERY_SOFT_SKILLS } from '../../../../graphql/query/note/softSkills.query';

const callBackOrder = (
  clearClient: () => ClearClientActions,
  clearCart: () => ClearCartAction,
  goback: () => void,
  setLoading: (arg: boolean) => void
) => ({
  refetchQueries: [
    { query: GET_LEADERS, variables: { tableau: 'classe' } },
    { query: QUERY_CLASSE_INFO },
    { query: QUERY_GET_MY_NOTE_IN_CLASSE, variables: { id: MY_ID } },
    { query: QUERY_SOFT_SKILLS }
  ],
  onCompleted: async (res: AddCommandesAndNoteMutation) => {
    await clearClient();
    await clearCart();
    boundSetFeedback({
      modal: {
        title: 'Récapitulatif de votre commande',
        actionButton: (
          <ButtonWithText content={'Revenir aux commandes'} onClick={goback} />
        )
      },
      isOpen: true,
      message: (
        <RecapCommande
          commande={getCommandeDefWithEleveFromQuery({
            attributes: res['addCommandesAndNote']
          })}
        />
      )
    });
  },
  onError: e => {
    boundSetFeedback({
      message: <CommandeErrorMessage error={e} />,
      modal: {
        title: 'Une erreur inattendue est survenue',
        actionButton: (
          <ButtonWithText
            content={'Aller sur la page "Mes ventes"'}
            onClick={goback}
          />
        )
      }
    });
    capture('Erreur commande Eleve', [{ extra: e, key: 'detail' }]);
    setTimeout(() => setLoading(false), 2000);
  }
});

export default callBackOrder;
